/**
 * 発注テーブル用 リマインドメールの件名・本文テンプレート
 * 各Modules配下に定数を置くルールに従い、このモジュール専用の定義とする。
 */

/** 件名 */
export const ORDER_REMINDER_SUBJECT = 'Order reminder from LEANPATH';

/**
 * 本文テンプレート生成
 * @param memo - ユーザーが入力したメモ
 * @returns 件名に対応する本文
 */
export const buildOrderReminderBody = (memo: string): string => {
  const memoJa = memo ?? '';
  const memoEn = memo ?? '';
  return [
    '本メールは自動送信です。This is an automated message.',
    '',
    'English follows Japanese',
    '',
    'LEAN PATHからのリマインダーです。',
    '下記の事項を確認してください。',
    '',
    'メモ',
    memoJa,
    '',
    '確認はこちらから（https://app.service.lean-path.com/#/firm-order）',
    '',
    'This is a reminder email from LEANPATH.',
    'Please check the following items.',
    '',
    'Memo',
    memoEn,
    '',
    'Click here to confirm(https://app.service.lean-path.com/#/firm-order）',
    '',
    'LEAN PATH Inc.',
  ].join('\n');
};
